/**
 * Lecteur EduFlow — clés player.* et titre d’onglet (complément i18n-ar).
 */
export const arPlayerTranslations: Record<string, string> = {
  'eduflow.player': 'مشغّل EduFlow',
  'player.next': 'التالي',
  'player.previous': 'السابق',
  'player.scrollDownHint': 'مرّروا لأسفل للمتابعة',
  'player.image.clickForAnnotations': 'انقروا على الصورة لعرض التعليقات التوضيحية',
  'player.complete': 'إنهاء',
  'player.exit': 'خروج',
  'player.fullscreen': 'ملء الشاشة',
  'player.exitFullscreen': 'إنهاء ملء الشاشة',
  'player.webinarFollowBanner':
    'تتبّعون المُقدّم — التنقل مقفل. يمكنكم تغيير لغة العرض عبر زر الكرة الأرضية.',
  'player.textBlockTipsHeading': 'نصائح',
  'player.textBlockReadDone': 'انتهت القراءة',
  'player.institutionLogo': 'شعار المؤسسة',
  'player.exitConfirmTitle': 'مغادرة التدريب؟',
  'player.exitConfirmMessage': 'سيُحفظ تقدّمكم. هل تريدون المغادرة؟',
  'player.focusLostTitle': 'التدريب متوقّف مؤقتًا',
  'player.focusLostMessage': 'لقد غادرتم نافذة التدريب. الوقت متوقّف مؤقتًا.',
  'player.focusLostResume': 'انقروا للمتابعة',
  'player.focusLostRemaining': 'الخروجات المتبقية قبل الحظر: {{remaining}}',
  'player.focusBlockedTitle': 'التدريب محظور',
  'player.focusBlockedMessage':
    'لقد تجاوزتم عدد الخروجات المسموح به ({{max}}). لم يعد بإمكانكم متابعة هذا التدريب.',
  'player.unblockRequestButton': 'طلب فتح التدريب من المدرّب',
  'player.unblockRequestAgain': 'طلب مرة أخرى',
  'player.unblockPending': 'تم إرسال الطلب — في انتظار رد المدرّب.',
  'player.unblockRejected': 'تم رفض طلب فتح التدريب.',
  'player.unblockLoginRequired': 'سجّلوا الدخول إلى حساب المتعلّم لطلب فتح التدريب.',
  'player.unblockRequestSent': 'تم إرسال الطلب إلى المدرّب.',
  'player.unblockRequestError': 'تعذّر إرسال الطلب. أعيدوا المحاولة.',
  'player.unblockApprovedToast': 'فتح المدرّب التدريب. يمكنكم المتابعة!',
  'player.registrationFormHint':
    'يُنشئ هذا النموذج حساب المتعلّم لهذا التدريب (البريد الإلكتروني والاسم الأول واسم العائلة مطلوبة).',
  'player.registrationFormSuccess': 'تم تسجيل الاشتراك. يمكنكم متابعة التدريب.',
  'player.registrationFormError': 'تعذّر حفظ التسجيل.',
  'player.cancel': 'إلغاء',
  'player.summary': 'فهرس',
  'player.summary.badge': 'خلاصة',
  'player.summary.noItems': 'لم يُعرَّف أي نقطة تلخيص لهذا القسم.',
  'player.summary.blockTranslating': 'جارٍ الترجمة…',
  'player.summary.blockSimplifying': 'جارٍ تبسيط النص…',
  'player.simplifiedTextLoadingTitle': 'جارٍ تجهيز النص المبسّط…',
  'player.simplifiedTextLoadingHint':
    'نُبسّط أولاً القسم المعروض، ثم بقيّة المسار في الخلفية.',
  'player.contents': 'المحتوى',
  'player.progress': 'التقدّم',
  'player.block': 'قسم',
  'player.parallelBranches': 'فروع متوازية',
  'player.parallelBranchesTitle': 'يُتبع',
  'player.parallelBranchesHint': 'ستُقترح الخيارات الأخرى لاحقًا.',
  'player.parallelBranchShowFull': 'عرض المزيد',
  'player.parallelBranchShowLess': 'عرض أقل',
  'player.parallelBranchChoose': 'فتح',
  'player.parallelBranchDismiss': 'إغلاق',
  'player.parallelBranchDismissHint':
    'العودة إلى القسم. استخدموا «التالي» لاختيار فرع.',
  'player.parallelBranchesPickTitle': 'اختاروا المسار التالي',
  'player.parallelBranchesPickHint':
    'المسارات المُكملة مُوسومة «منتهية». تجاوزوا كل فرع متبقٍ قبل مواصلة المسار المشترك.',
  'player.parallelBranchFromBlock': 'من: {{title}}',
  'player.parallelBranchesProgress': '{{done}} / {{total}} مسارات مُكملة',
  'player.parallelBranchesOverview': 'التقدّم',
  'player.parallelBranchStatusDone': 'منتهية',
  'player.parallelBranchStatusTodo': 'قيد الانتظار',
  'player.parallelBranchStatusNext': 'المطلوب الآن',
  'player.parallelBranchAction': 'اختيار هذا المسار',
  'player.notes': 'دوّنوا ملاحظات…',
  'player.noBlocks': 'لا توجد أقسام للعرض.',
  'player.contentTranslatingTitle': 'تكييف المحتوى مع لغتكم…',
  'player.contentTranslatingHint': 'ترجمة وتنسيق جارٍ. قد يستغرق الأمر وقتًا في المرة الأولى.',
  'player.contentLanguageReloadFailed':
    'تعذّر إعادة تحميل المحتوى بهذه اللغة (انتهاء المهلة أو خطأ). ما زالت النسخة السابقة معروضة. أعيدوا المحاولة بعد لحظات أو سبقوا الترجمة من المُصمّم.',
  'player.contentLanguageSubflowHint':
    'لتحديث النص والصوت، أنهوا الجزء الفرعي الحالي أو اخرجوا منه ثم اختاروا اللغة من جديد.',
  'player.loading': 'جارٍ تحميل المحتوى…',
  'player.pleaseWait': 'يرجى الانتظار لحظة.',
  'player.defaultFlowTitle': 'تدريب',
  'player.docTitle.error': 'تدريب غير متاح',
  'player.docTitle.completed': 'اكتمل التدريب',
  'player.docTitle.loading': 'جارٍ تحميل التدريب',
  'player.docTitle.fallback': 'تدريب',
  'player.initError.title': 'التدريب غير متاح مؤقتًا',
  'player.initError.loadFailed': 'تعذّر تحميل التدريب في الوقت الحالي.',
  'player.initError.loadFailedWithDetail':
    'تعذّر تحميل التدريب في الوقت الحالي.{{detail}} يرجى إعادة المحاولة بعد لحظات.',
  'player.initError.hintsIntro': 'يمكنكم:',
  'player.initError.hintRefresh': 'تحديث الصفحة؛',
  'player.initError.hintConnection': 'التحقق من اتصال الإنترنت؛',
  'player.initError.hintRetryLater': 'إعادة المحاولة بعد دقائق.',
  'player.textBlockReadMinutes': '{{count}} دقيقة قراءة',
  'player.textBlockWordCount_one': '{{count}} كلمة',
  'player.textBlockWordCount_other': '{{count}} كلمات',
  'player.textBlockNoContent': 'لا محتوى متاحًا.',
  'player.blockUnknown': 'قسم غير معروف',
  'player.objectivesPanelTitle': 'الأهداف التربوية',
  'player.objectivesOpenLabel': 'عرض الأهداف التربوية',
  'player.objectivesCloseLabel': 'إغلاق لوحة الأهداف',
  'player.objectivesAchievementRate': 'معدّل التحقق',
  'player.objectivesAchievedCount': '{{achieved}}/{{total}} أهداف محقّقة',
  'player.objectivesNoneDefined': 'لا أهداف مُعرَّفة لهذا التدريب.',
  'player.objectiveCategory.savoir': 'معرفة',
  'player.objectiveCategory.savoirFaire': 'مهارة',
  'player.objectiveCategory.savoirEtre': 'كفاءة سلوكية',
  'player.objectiveLevel.connaissance': 'معرفة',
  'player.objectiveLevel.comprehension': 'فهم',
  'player.objectiveLevel.application': 'تطبيق',
  'player.objectiveLevel.analyse': 'تحليل',
  'player.objectiveLevel.synthese': 'تركيب',
  'player.objectiveLevel.evaluation': 'تقييم',
  'player.objectiveBloom': 'بلوم · {{level}}',
  'player.objectiveRequired': 'إلزامي',
  'player.objectiveLinkedBlocks': 'أقسام مرتبطة',
  'player.objectiveCriterionScore': 'درجة ≥ {{min}}٪',
  'player.objectiveCriterionCompletion': 'إكمال القسم',
  'player.objectiveNoLinkedBlocks': 'لا أقسام مرتبطة — التقدّم العام لا يحسب هذا الهدف.',
  'player.completion.congratulations': '🎉 تهانينا!',
  'player.completion.finished': '📋 اكتمل المسار',
  'player.completion.youCompleted': 'لقد أتممتم',
  'player.completion.passed': 'ناجح ✓',
  'player.completion.failed': 'غير مُصدَّق ✗',
  'player.completion.requiredScore': 'الحد المطلوب: {{score}}٪',
  'player.completion.totalTime': 'الوقت الإجمالي',
  'player.completion.blocksCompleted': 'أقسام مُكملة',
  'player.completion.quizPassed': 'اختبارات ناجحة',
  'player.completion.successRate': 'معدّل النجاح',
  'player.completion.blockCompleted': 'مُكتمل ✓',
  'player.completion.blockFailed': 'راسب ✗',
  'player.completion.blockSkipped': 'متخطّى',
  'player.completion.detail': '📊 تفصيل حسب القسم',
  'player.completion.type': 'النوع',
  'player.completion.timeSpent': 'الوقت المستغرق',
  'player.completion.downloadCertificate': '📄 تنزيل الشهادة',
  'player.completion.certificateSoon': 'ستُتاح الشهادة قريبًا.',
  'player.completion.restart': '🔄 إعادة البدء',
  'player.completion.viewDetails': '📊 عرض التفاصيل',
  'player.completion.backToDashboard': '← العودة إلى لوحة التحكم',
  'player.completion.embedDismissHint':
    'أنهيتم هذا الموديول. للخروج استخدموا علامة × أعلى اليمين أو الزر أدناه.',
  'player.completion.embedDismissButton': 'إغلاق النافذة',
  'player.lightMode': 'الوضع الفاتح',
  'player.darkMode': 'الوضع الداكن',
  'player.previewBanner': 'وضع المعاينة — تعرض هذه الشاشة البيانات الحقيقية لتدريبكم',
  'player.closePreview': 'إغلاق المعاينة',
  'player.flowPreviewMap': 'مخطط المسار',
  'player.flowPreviewTitle': 'معاينة المسار',
  'player.flowPreviewHint':
    'عرض ثابت (كما في المصمّم). الإطار البرتقالي يشير إلى القسم المعروض في المشغّل.',
  'player.flowPreviewLegendCurrent': 'القسم المعروض',
  'player.flowPreviewClose': 'إغلاق',
  'player.toggleSidebarShow': 'إظهار اللوحة',
  'player.toggleSidebarHide': 'إخفاء اللوحة',
  'player.mobileSummary': 'الفهرس',
  'player.mobileObjectives': 'الأهداف',
  'player.mobileMoreOptions': 'المزيد',
  'player.sidebarExpand': 'توسيع اللوحة',
  'player.sidebarCollapse': 'طي اللوحة',
  'player.keyboardShortcuts': 'اختصارات لوحة المفاتيح',
  'player.keyboardShortcutPrev': 'القسم السابق',
  'player.keyboardShortcutNext': 'القسم التالي',
  'player.keyboardShortcutsHint':
    'فعّلوا «التنقل بلوحة المفاتيح» في مركز إتاحة الوصول (زر أسفل اليمين). لا يعمل في حقول الإدخال.',
  'player.a11yCenter': 'مركز إتاحة الوصول',
  'player.reviewSummary': 'عرض الملخص',
  'player.viewResults': 'عرض النتائج',
  'player.submitFirst': 'أرسِلوا أولاً',
  'player.phraseRevealCompleteFirst': 'طالعوا جميع العبارات',
  'player.phraseReveal.emptyBlock': 'لا عبارات مُعدّة لهذا القسم.',
  'player.phraseReveal.revealNextAria': 'انقر أو اضغط المسافة لإظهار العبارة التالية',
  'player.phraseReveal.lastPhraseHint': 'آخر عبارة — استخدموا «التالي» لمواصلة المسار.',
  'player.phraseReveal.morePhrasesHint': 'نقرة، مسافة أو سهم يمين للمتابعة',
  'player.phraseReveal.previousPhrases': 'عبارات سابقة ({{count}})',
  'player.certificateUnavailable': 'ستُتاح الشهادة قريبًا.',
  'player.browser.embeddedContentTitle': 'محتوى مدمج',
  'player.browser.noValidUrl': 'لا عنوان URL صالح',
  'player.browser.enterHttpsHint':
    'أدخلوا عنوانًا يبدأ بـ https:// (أو http://) في إعدادات القسم.',
  'player.browser.loadingContent': 'جارٍ تحميل المحتوى…',
  'player.browser.defaultPageTitle': 'صفحة ويب مدمجة',
  'player.browser.continue': 'متابعة',
  'player.browser.stepSaved': 'تم حفظ الخطوة',
  'player.browser.fullscreen': 'ملء الشاشة',
  'player.browser.exitFullscreen': 'إنهاء ملء الشاشة',
  'player.podcast.defaultShowTitle': 'بودكاست',
  'player.podcast.defaultEpisode': 'حلقة',
  'player.podcast.loadError': 'تعذّر تحميل البودكاست.',
  'player.podcast.loadingEpisodes': 'جارٍ تحميل الحلقات…',
  'player.podcast.playAll': 'تشغيل الكل',
  'player.podcast.nextEpisode': 'الحلقة التالية',
  'player.podcast.episodesHeading': 'الحلقات',
  'player.podcast.noEpisodes': 'لا حلقات.',
  'player.podcast.noAudio': 'لا صوت',
  'player.podcast.chainPlayback': 'تشغيل متسلسل · {{current}}/{{total}}',
  'player.podcast.selectOrPlayAll': 'اختاروا حلقة من القائمة أو شغّلوا «تشغيل الكل».',
  'player.podcast.audioUnavailable': 'الصوت غير متاح لهذه الحلقة.',
  'player.podcast.showEpisodeText': 'عرض النص',
  'player.podcast.hideEpisodeText': 'إخفاء النص',
  'player.podcast.episodeCount_one': '{{count}} حلقة',
  'player.podcast.episodeCount_other': '{{count}} حلقات',
  'player.podcast.showChapters': 'إظهار الفصول',
  'player.podcast.hideChapters': 'إخفاء الفصول',
  'player.podcast.coverDialogLabel': 'غلاف: {{title}}',
  'player.podcast.coverEnlargePodcast': 'تكبير غلاف البودكاست',
  'player.podcast.coverEnlargeEpisode': 'تكبير غلاف الحلقة',
  'player.podcast.coverEnlarge': 'تكبير الغلاف',
  'player.audio.play': 'تشغيل',
  'player.audio.pause': 'إيقاف مؤقت',
  'player.audio.mute': 'كتم الصوت',
  'player.audio.unmute': 'إعادة الصوت',
  'player.audio.seek': 'موضع في المسار الصوتي',
  'player.audio.playbackSpeed': 'سرعة التشغيل',
  'player.audio.completed': 'انتهى المسار الصوتي',
  'player.audio.subtitlesAria': 'نص متزامن مع التشغيل',
  'player.audio.subtitlesWaiting': 'ستظهر مقاطع النص هنا أثناء التشغيل.',
  'player.audio.subtitlesNeedText': 'أضيفوا نصًا (TTS أو محتوى القسم) لعرض المقاطع هنا.',
  'player.audio.subtitlesHintSr':
    'مزامنة تقريبية: يُوزَّع النص على مدة الصوت دون طوابع زمنية كلمة بكلمة.',
  'player.video.seek': 'موضع في الفيديو',
  'player.video.subtitlesShow': 'إظهار الترجمة',
  'player.video.subtitlesHide': 'إخفاء الترجمة',
  'player.video.trackLabel': 'ترجمات',
  'player.video.completed': 'اكتمل الفيديو',
  'player.video.markWatched': 'لقد شاهدت الفيديو',
  'player.video.defaultIframeTitle': 'فيديو مدمج',
  'player.podcast.playAllAria': 'تشغيل الكل «{{title}}» — {{count}} حلقة/حلقات بملف صوتي',
  'player.podcast.skipNextQueuedAria': 'الانتقال إلى الحلقة التالية في قائمة التشغيل',
  'player.podcast.playEpisodeAria': 'تشغيل الحلقة: {{title}}',
  'player.podcast.episodeNoAudioAria': 'حلقة بلا ملف صوتي: {{title}}',
  'player.renderError': 'خطأ أثناء عرض القسم: {{blockType}}',
  'player.blocks.defaultWelcome': 'مرحبًا بكم في هذا التدريب',
  'player.blocks.defaultEndTitle': 'تهانينا!',
  'player.quiz.selectCorrectAnswer': 'اختاروا الإجابة الصحيحة:',
  'player.quiz.correctAnswer': '✓ إجابة صحيحة!',
  'player.quiz.incorrectAnswer': '✗ إجابة خاطئة.',
  'player.blockTimer.aria': 'الوقت المتبقي لهذا القسم',
  'player.blockTimer.modeShortCountup': 'زمن',
  'player.blockTimer.modeShortCountdown': 'عد تنازلي',
  'player.form.successMessage': 'شكرًا على إجابتكم!',
  'player.form.noFieldsConfigured': 'لم تُضَبط بعد حقول لهذا النموذج.',
  'player.selfAssessment.empty': 'لا معايير مُعرَّفة لهذا التقييم الذاتي.',
  'player.selfAssessment.continue': 'متابعة',
  'player.selfAssessment.pick': 'اختاروا درجة',
  'player.selfAssessment.rateAria': 'درجة {{n}}: {{label}}',
  'player.selfAssessment.criterionFallback': 'معيار',
  'player.selfAssessment.commentLabel': 'تعليق (اختياري)',
  'player.selfAssessment.commentPlaceholder': 'تأملات، محاور تحسين…',
  'player.selfAssessment.submitted': 'تم حفظ الإجابات.',
  'player.selfAssessment.submit': 'تأكيد التقييم الذاتي',
  'player.selfAssessment.textAnswerPlaceholder': 'إجابتكم…',
  'player.selfAssessment.pickBadges': 'اختاروا واحدًا أو أكثر:',
  'player.evaluation.commentsLabel': 'تعليقات (اختياري)',
  'player.evaluation.commentsPlaceholder': 'شاركوا رأيكم…',
  'player.evaluation.submitted': 'تم إرسال التقييم',
  'player.evaluation.submit': 'إرسال التقييم',
  'player.time.lessThanMinute': 'أقل من دقيقة',
  'player.time.oneMinute': 'دقيقة واحدة',
  'player.time.minutes': '{{count}} دقائق',
  'player.time.shortSeconds': '{{count}}ث',
  'player.time.shortMinutes': '{{count}}د',
  'player.time.shortMinutesSeconds': '{{minutes}}د {{seconds}}ث',
  'player.completion.scoreLabel': 'النتيجة',
  'player.adaptivePrompt.title': 'نسخة مُبسّطة متاحة لهذا القسم',
  'player.adaptivePrompt.subtitle': 'هل تريدون نسخة تفاعلية أكثر إتاحة؟',
  'player.adaptivePrompt.useSimplified': 'استخدام النسخة المُبسّطة',
  'player.adaptivePrompt.keepOriginal': 'الإبقاء على القسم القياسي',
  'player.descriptionTeleprompter': 'وضع المُرقِع',
  'player.descriptionTeleprompterOff': 'عرض القسم',
  'player.descriptionVoiceover': 'تعليق صوتي — وصف القسم',
  'player.adaptiveGame.title': 'نسخة تفاعلية مُبسّطة',
  'player.adaptiveGame.subtitle': 'بديل أكثر إتاحة للتحقق من هذا الهدف.',
  'player.adaptiveGame.step': 'الخطوة {{index}} / {{total}}',
  'player.adaptiveGame.validate': 'تأكيد',
  'player.adaptiveGame.next': 'الخطوة التالية',
  'player.adaptiveGame.done': 'هدف محقّق في الوضع المُبسّط',
  'player.teleprompterPrevParagraph': 'الفقرة السابقة',
  'player.teleprompterNextParagraph': 'الفقرة التالية',
  'player.timeline.defaultTitle': 'خط زمني',
  'player.timeline.subtitle': 'خط زمني للتصفّح.',
  'player.timeline.eventFallback': 'حدث',
  'player.timeline.voiceoverLabel': 'تعليق صوتي',
  'player.timeline.playVoiceover': 'تشغيل التعليق الصوتي',
  'player.timeline.pauseVoiceover': 'إيقاف التعليق الصوتي',
  'player.timeline.generateVoiceover': 'توليد التعليق الصوتي',
  'player.timeline.showDetail': 'عرض التفاصيل',
  'player.timeline.hideDetail': 'إخفاء التفاصيل',
  'player.timeline.emptyTitle': 'لا أحداث في هذا الخط الزمني',
  'player.timeline.emptyHint': 'أضيفوا خطوات من لوحة إعدادات القسم.',
  'player.timeline.voiceoverUnavailableTitle': 'التعليق الصوتي غير متاح',
  'player.timeline.voiceoverUnavailableDesc':
    'افتحوا هذا المسار من تدريب متصل لتوليد الصوت.',
  'player.timeline.voiceoverTextTooShortTitle': 'النص قصير جدًا',
  'player.timeline.voiceoverTextTooShortDesc':
    'أضيفوا وصفًا (20 حرفًا على الأقل) أو عنوانًا أكثر تفصيلاً للتعليق الصوتي.',
  'player.timeline.voiceoverGenerationErrorTitle': 'تعذّر توليد التعليق الصوتي',
  'player.timeline.voiceoverSlowTitle': 'تعليق صوتي',
  'player.timeline.voiceoverSlowDesc':
    'التوليد يستغرق وقتًا أطول من المتوقع. أعيدوا المحاولة بعد لحظات.',
  'player.timeline.retryLater': 'يرجى إعادة المحاولة لاحقًا.',
  'player.timeline.openFullscreen': 'فتح بملء الشاشة',
  'player.timeline.openFullscreenAria': 'فتح الخط الزمني بملء الشاشة',
  'player.timeline.closeFullscreenAria': 'إغلاق وضع ملء الشاشة',
  'player.timeline.reviewed': 'تمت مراجعة الخط الزمني',
};
